// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3V71-","amount":"Amount_amount__3Q_J6","tip":"Amount_tip__39tw1","tipHeader":"Amount_tipHeader__FzXvl","tipsWrap":"Amount_tipsWrap__3ehuA"};